// extracted by mini-css-extract-plugin
export default {"catalogItem":"CatalogItem_catalogItem__qkp8c","catalogItemText":"CatalogItem_catalogItemText__-iEtp"};